var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 16.1a1.24 1.24 0 11-1.65 1.9l-.1-.09L7.52 12l5.83-5.85a1.25 1.25 0 111.86 1.66l-.09.09L11 12l4.07 4.07z"
})));

export default SvgIconChevron;